export const eventServiceQueryKeys = {
    all: ["eventService"] as const,
    eventsByOrganizationId: (organizationId: string) =>
        [
            ...eventServiceQueryKeys.all,
            "eventsByOrganizationId",
            organizationId,
        ] as const,
};
